import { getAuth, signOut } from 'firebase/auth';
import serverErrorHandler from 'services/serverError.service';
import useUserStore from 'store/useUserStore';
import {
  clearPostLoginRedirect,
  setSuppressNextPostLoginPreserve,
} from 'utils/postLoginRedirect';

// handles user logout
export default function useLogout() {
  const logout = async () => {
    try {
      // Don't save the page the user signed out from as the next login's
      // destination (shared office devices: next student would land there).
      clearPostLoginRedirect();
      setSuppressNextPostLoginPreserve();
      const auth = getAuth();
      await signOut(auth);
      useUserStore.getState().logout();
    } catch (e) {
      serverErrorHandler(e);
    }
  };
  return { logout };
}
